import { BodyText } from '@kvdbil/components';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const Container = styled(BodyText)`
  color: ${({ theme }) => theme.colors.error.dark};
  text-align: center;
`;

interface Props {
  text?: ReactNode;
  id?: string;
  withDefaultErrorText?: boolean;
}

const ErrorText = ({ text, id, withDefaultErrorText = false }: Props) => {
  const { t } = useTranslation();
  return (
    <Container as="div" role="alert" aria-live="assertive" id={id}>
      {withDefaultErrorText
        ? t('Something went wrong, please try again later.')
        : text}
    </Container>
  );
};

export default ErrorText;
